import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import themes from "@/themes/default/colors.json";
import store from "@/store";
import en from "vuetify/src/locale/en";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { en },
    current: store.getters["localization/getCurrent"]
  },
  theme: {
    options: {
      customProperties: true
    },
    themes
  }
});
